import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

import Core from "./components/Core";
import "./index.css";
import BlogMapDesktop from "./pages/Blogs/BlogMapDesktop";
import BlogMapMobile from "./pages/Blogs/BlogMapMobile";
import ThesisDesktop from "./pages/Projects/ThesisPageDesktop";
import ThesisMobile from "./pages/Projects/ThesisPageMobile";
import FullProjectsPageDesktop from "./pages/Full Projects/FullProjectsPageDesktop";
import FullProjectsPageMobile from "./pages/Full Projects/FullProjectsPageMobile";
import ENSF619PageDesktop from "./pages/Projects/ENSF619PageDesktop";
import ENSF619PageMobile from "./pages/Projects/ENSF619PageMobile";

export default function App() {
  const isDesktopOrLaptop = useMediaQuery({ minWidth: 768 });
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <Router>
      <div className="font-normal text-[16px] tracking-[0.015em] text-custom-white min-h-screen bg-gray-1">
        <Routes>
          <Route path="/" element={<Core />} />

          {isDesktopOrLaptop && (
            <>
              <Route path="/blog/map" element={<BlogMapDesktop />} />
              <Route path="/projects/thesis" element={<ThesisDesktop />} />
              <Route
                path="/projects/commit-vulnerability-predictor"
                element={<ENSF619PageDesktop />}
              />
              <Route
                path="/full-projects"
                element={<FullProjectsPageDesktop />}
              />
            </>
          )}
          {isMobile && (
            <>
              <Route path="/blog/map" element={<BlogMapMobile />} />
              <Route path="/projects/thesis" element={<ThesisMobile />} />
              <Route
                path="/projects/commit-vulnerability-predictor"
                element={<ENSF619PageMobile />}
              />

              <Route
                path="/full-projects"
                element={<FullProjectsPageMobile />}
              />
            </>
          )}
        </Routes>
      </div>
    </Router>
  );
}
